import { memo } from 'react';
import Box from '@mui/material/Box';
// Local files
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import SecondFlow from 'components/Flows/SecondFlows/SecondFlows';
import SecondAnalysisDrawer from 'components/Analyses/SecondAnalyses/Drawer/Drawer';

const SecondFlows = () => {

  return (
    <Box sx={{ flexGrow: 1, display: 'flex', overflow: 'hidden'  }}>
      <SecondAnalysisDrawer />
      <SecondFlow />
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <SecondFlows {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);